import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import Modal from './SimpleModal'; // Você pode criar um SimpleModal ou usar um modal já existente
import getCroppedImg from '../../utils/cropImage';

const ImageCropModal = ({ open, image, onClose, onCropComplete }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const onCropChange = (crop) => setCrop(crop);
  const onZoomChange = (zoom) => setZoom(zoom);

  const onCropCompleteHandler = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleCrop = async () => {
    const croppedImage = await getCroppedImg(image, croppedAreaPixels);
    onCropComplete(croppedImage);
  };

  return (
    <Modal open={open} onClose={onClose} title="Ajustar foto">
      <div style={{ position: 'relative', width: '100%', height: 350, background: '#333' }}>
        <Cropper
          image={image}
          crop={crop}
          zoom={zoom}
          aspect={1}
          onCropChange={onCropChange}
          onZoomChange={onZoomChange}
          onCropComplete={onCropCompleteHandler}
        />
      </div>
      <div style={{ marginTop: 16, display: 'flex', justifyContent: 'center', gap: 16 }}>
        <input
          type="range"
          min={1}
          max={3}
          step={0.01}
          value={zoom}
          onChange={(e) => setZoom(Number(e.target.value))}
          style={{ width: 150 }}
        />
        <button onClick={handleCrop} className="student-photo-upload-btn">Confirmar</button>
        <button onClick={onClose} className="student-photo-remove-btn">Cancelar</button>
      </div>
    </Modal>
  );
};

export default ImageCropModal;
